import Header from "../components/Header";
import Footer from "../components/Footer";
import HowWeWork from "../components/About/howwework";
import ServiceGrid from "../components/About/servicegrid";
import Work from "../components/Home/work";
import TeamSection from "../components/About/teamsection";
import TechnicalExpertise from "../components/About/techinalexprtise";
import Mission from "../components/Home/mission";
import TitleBanner from "../components/titlebanner";

export default function About() {
    return (
        <>
            <Header />
            <TitleBanner  title={"About Us"}/>
            <HowWeWork/>
            <TechnicalExpertise/>
            <ServiceGrid/>
            <Work/>
            <Mission/>
            <TeamSection/> 
            <Footer />
        </>
    )
}